import { render, staticRenderFns } from "./sendmoney-confirmation.vue?vue&type=template&id=5124938b&"
import script from "./sendmoney-confirmation.vue?vue&type=script&lang=js&"
export * from "./sendmoney-confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports